const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LANGS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "mr", label: "मराठी" },
  { code: "gu", label: "ગુજરાતી" },
];

export const getLang = () => {
  try { return localStorage.getItem("gf_lang") || "en"; } catch { return "en"; }
};
export const setLang = (code) => {
  try { localStorage.setItem("gf_lang", code); } catch {}
  window.location.reload();
};

const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "IFRAME", "CODE", "TEXTAREA", "INPUT", "SELECT", "OPTION"]);
const memo = new Map();
let observing = false;
let pending = null;

const collectNodes = (root) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode: (n) => {
      const p = n.parentElement;
      if (!p || SKIP_TAGS.has(p.tagName) || p.closest("[data-no-translate],[lang='hi']")) return NodeFilter.FILTER_REJECT;
      const t = n.textContent;
      if (!t || !t.trim() || t.trim().length < 2) return NodeFilter.FILTER_REJECT;
      if (!/[A-Za-z]{2,}/.test(t)) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });
  const nodes = [];
  let n;
  while ((n = walker.nextNode())) nodes.push(n);
  return nodes;
};

const applyMap = (nodes, map) => {
  for (const n of nodes) {
    const key = n.textContent.trim();
    const tr = map.get(key);
    if (tr && tr !== key) {
      const t = n.textContent;
      n.textContent = t.replace(key, tr);
      if (n.parentElement) n.parentElement.setAttribute("data-i18n-done", "1");
    }
  }
};

export const translatePage = async (lang, root = document.body) => {
  if (!lang || lang === "en") return;
  const nodes = collectNodes(root).filter((n) => !n.parentElement?.getAttribute("data-i18n-done"));
  if (!nodes.length) return;
  const keys = [...new Set(nodes.map((n) => n.textContent.trim()))];
  const need = keys.filter((k) => !memo.has(k)).slice(0, 250);
  if (need.length) {
    try {
      const r = await fetch(`${API}/i18n/translate`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lang, texts: need }),
      });
      if (r.ok) {
        const d = await r.json();
        Object.entries(d.map || {}).forEach(([k, v]) => memo.set(k, v));
      }
    } catch {}
  }
  applyMap(nodes, memo);
};

export const initI18n = () => {
  const lang = getLang();
  document.documentElement.lang = lang;
  // hreflang alternates for SEO
  const path = window.location.pathname;
  const head = document.head;
  head.querySelectorAll("link[data-i18n-alt]").forEach((e) => e.remove());
  for (const l of [...LANGS.map((x) => x.code), "x-default"]) {
    const link = document.createElement("link");
    link.rel = "alternate";
    link.hreflang = l;
    link.href = `https://growthifye.com${path}${l === "en" || l === "x-default" ? "" : `?lang=${l}`}`;
    link.setAttribute("data-i18n-alt", "1");
    head.appendChild(link);
  }
  if (lang === "en") return;
  startTranslator(lang);
};

let curLang = "en";
export const startTranslator = (lang) => {
  curLang = lang;
  if (lang === "en") return;
  document.documentElement.lang = lang;
  const run = () => curLang !== "en" && translatePage(curLang);
  setTimeout(run, 400);
  if (!observing) {
    observing = true;
    const obs = new MutationObserver(() => {
      clearTimeout(pending);
      pending = setTimeout(run, 900);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
};
